<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <div :class="b('heading')">
      <h1 :class="b('title')">{{ $t("История") }}</h1>
      <p :class="b('subtitle')">
        {{ $t("Пополнения, выводы и заявки на обмен") }}
      </p>
    </div>

    <section :class="b('wrapper')">
      <div :class="b('inner')">
        <HistoryHeader @refresh="handleFetch" />

        <transition name="history-filter-slide">
          <HistoryFilters
            v-if="isFilter"
            :currency="displayedCurrency"
            @apply="handleFetch"
          />
        </transition>

        <HistoryTable
          :key="displayedTab"
          :class="b('table')"
          :history="history"
          :last-fetch-count="lastFetchCount"
          :loading="isLoading"
          @depositWithdrawal="handleDepositWithdrawal"
          @application="handleApplication"
          @remove="handleConfirm"
          @show-more="handleMore"
        />
      </div>
    </section>

    <transition name="opacity">
      <HistoryDetails
        v-if="depositWithdrawal"
        :class="b('modal')"
        :deposit-withdrawal="depositWithdrawal"
        @depositWithdrawal="handleDepositWithdrawal"
      />
    </transition>

    <transition name="opacity">
      <HistoryApplicationDetails
        v-if="application"
        :class="b('modal')"
        :application="application"
        @application="handleApplication"
      />
    </transition>

    <transition name="opacity">
      <HistoryRemove
        v-if="isConfirmShow"
        :class="b('modal')"
        @close="handleConfirm"
        @remove="handleRemove"
      />
    </transition>
  </div>
</template>
